export const routes = {
  aboutUs: '/about-us',
  enterprise: '/enterprise',
  executives: '/executives',
  careerAdvice: '/career-advice',
  resourcesCategory: '/career-advice/:category',
  article: '/career-advice/:slug',
  articlePreview: '/preview/article/:slug',
  author: '/author/:slug',
  termsOfUse: '/tos',
  privacyPolicy: '/privacy',
  cookiePolicy: '/cookie-policy',
  pricing: '/pricing',
  contactUs: '/contact-us',
  contact: '/contact',
  doNotSell: '/do-not-sell',
  jobSearch: '/jobs',
  events: '/events',
  resumeBuilder: 'resume-builder',
  unsubscribeEmails: 'unsubscribe-emails/:token',
  confirmationPage: 'confirmation-page/:token',
}

export const resourcesList: Record<string, string> = {
  gatedArticleContent: '/resources/:slug/gated-content.json',
}

export const superAppApi: Record<string, string> = {
  account: '/api/app/account',
  suggestions: '/api/app/suggest',
  prefill: '/api/app/jobs/prefill',
  jobSearch: '/api/jobs/v1/search',
  eventsSearch: '/api/premier-virtual/events',
  jobDetails: '/api/jobs/v1/search',
  talentMatch: '/api/app/resumes/api_flashrecruit',
  getAddress: '/api/jobs/v1/search/location',
  resumeCritique: '/api/app/resume_critique',
  applyHaley: '/api/app/haley_resume',
  postResume: '/api/post-cv',
  resumeTemplates: '/api/builder/resumes/lander-templates',
  register: '/api/builder/resume_upload/register',
  uploadAndParse: '/api/builder/resume_upload/upload_and_parse',
}
